<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitlea"><a id="page_ii"></a><a id="page_iii"></a>THE</p>
<p class="halftitle">Tribal<br/>Knot</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?449ac5d2